<template>
  <div>
  <el-select
    name="user"
    placeholder="All"
    filterable
    prefix-icon="el-icon-search" 
    remote
    :remote-method="userSearch"
    default-first-option
    :allow-create="false"
    :clearable="true"
    v-model="user"
    :value="value"
    :loading="loadingUsers"
    v-loading="loadingUsers"
    element-loading-spinner="qc-spinner"
    value-key="username"
    class="verification-select"
    @change="$emit('input', $event)" >
    <el-option-group v-if="userOptions != null && userOptions.length > 0" :label="'Type to search and select an option below'">
      <el-option
        v-for="item in userOptions"
        :key="item.username"
        :label="item.firstname + ' ' + item.lastname + ' (' + item.username + ')'"
        :value="item.username"
        :disabled="item.disabled">
      </el-option>
    </el-option-group>
  </el-select>
  </div>
</template>

<script>
export default {
  name: 'user-select',
  props: {
    value: String,
    includePending: { type: Boolean, default: false },
    orderBy: { type: String, default: "firstname" }
  },
  data () {
    return {
      user: this.value,
      loadingUsers: false,
      userOptions: this.value ? [this.value] : []
    }
  },
  watch: {
    value (value) {
      this.user = value
    }
  },
  methods: {
    userSearch(query) {
      if(query != null) {
        this.loadingUsers = true
        this.doUserSearch(query)
      }
    },
    doUserSearch:_.debounce(function(query) {
      this.$api.getUsers(query, this.includePending, this.orderBy)
        .then(response => {
          this.userOptions = response.data
          this.loadingUsers = false
        })
        .catch(error => {
          console.log("Failed to load users")
          console.log(error)
          this.loadingUsers = false
        })  
    }, 200)
  }
}
</script>